(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7393],{

/***/ 99147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PostReActions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14924);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87066);
/* harmony import */ var components_common_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37975);
/* harmony import */ var _PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(16138);
/* harmony import */ var _PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var store_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8405);
/* harmony import */ var common_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22467);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _amplitude_analytics_browser__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(38367);
/* harmony import */ var store_post_reaction__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69372);
/* harmony import */ var _bugsnag_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64061);
/* harmony import */ var _bugsnag_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_bugsnag_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var lib_axios__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92282);

















var likeCountDiff = function(isLiked, currentLikedStatus) {
    if (!currentLikedStatus || !(0,lib_axios__WEBPACK_IMPORTED_MODULE_9__/* .isBoolean */ .jn)(currentLikedStatus === null || currentLikedStatus === void 0 ? void 0 : currentLikedStatus.isLiked) || (currentLikedStatus === null || currentLikedStatus === void 0 ? void 0 : currentLikedStatus.isLiked) === isLiked) {
        return 0;
    }
    if (isLiked && !(currentLikedStatus === null || currentLikedStatus === void 0 ? void 0 : currentLikedStatus.isLiked)) {
        return -1;
    }
    if (!isLiked && (currentLikedStatus === null || currentLikedStatus === void 0 ? void 0 : currentLikedStatus.isLiked)) {
        return 1;
    }
};
function PostReActions(param) {
    var post = param.post, _isPostDetail = param.isPostDetail, isPostDetail = _isPostDetail === void 0 ? false : _isPostDetail, handleClickComment = param.handleClickComment, _showViewCount = param.showViewCount, showViewCount = _showViewCount === void 0 ? false : _showViewCount, _smallSize = param.smallSize, smallSize = _smallSize === void 0 ? false : _smallSize, _showNumber = param.showNumber, showNumber = _showNumber === void 0 ? false : _showNumber, screen = param.screen;
    var showLogin = (0,store_global__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(state) {
        return state.showLogin;
    });
    var currentAuth = (0,store_global__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(state) {
        return state.currentAuth;
    });
    var likedPostsInfo = (0,store_post_reaction__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(state) {
        return state.likedPostsInfo;
    });
    var updateLikeInfoOfPost = (0,store_post_reaction__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(state) {
        return state.updateLikeInfoOfPost;
    });
    var sharePostsInfo = (0,store_post_reaction__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(state) {
        return state.sharePostsInfo;
    });
    var addShareInfoOfPost = (0,store_post_reaction__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(state) {
        return state.addShareInfoOfPost;
    });
    // use local state to make sure user's action is immediate
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(function() {
        var ref;
        var diff = likeCountDiff(post.is_liked, likedPostsInfo === null || likedPostsInfo === void 0 ? void 0 : likedPostsInfo[String(post.id)]);
        return diff === 0 ? post.is_liked : !!(likedPostsInfo === null || likedPostsInfo === void 0 ? void 0 : (ref = likedPostsInfo[String(post.id)]) === null || ref === void 0 ? void 0 : ref.isLiked);
    }), isLiked = ref[0], setIsLiked = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(post.is_shared), isShared = ref1[0], setIsShared = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(function() {
        return Math.max(post.like_count + likeCountDiff(post.is_liked, likedPostsInfo === null || likedPostsInfo === void 0 ? void 0 : likedPostsInfo[String(post.id)]), 0);
    }), likeCount = ref2[0], setLikeCount = ref2[1];
    var setPostToShareByPopup = (0,store_global__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(state) {
        return state.setPostToShareByPopup;
    });
    var isMobileScreen = (0,common_utils__WEBPACK_IMPORTED_MODULE_5__/* .useMediaQuery */ .ac)("(max-width: 767px)");
    var viewCountWidthPer = showViewCount ? 16 : 0;
    var shareMenuRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref, ref1;
        var diff = likeCountDiff(post.is_liked, likedPostsInfo === null || likedPostsInfo === void 0 ? void 0 : likedPostsInfo[String(post.id)]);
        setIsLiked(diff === 0 ? post.is_liked : !!(likedPostsInfo === null || likedPostsInfo === void 0 ? void 0 : (ref = likedPostsInfo[String(post.id)]) === null || ref === void 0 ? void 0 : ref.isLiked));
        setIsShared((sharePostsInfo === null || sharePostsInfo === void 0 ? void 0 : (ref1 = sharePostsInfo[String(post.id)]) === null || ref1 === void 0 ? void 0 : ref1.isShared) || post.is_shared);
        setLikeCount(Math.max(post.like_count + diff, 0));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        post.like_count,
        post.is_shared,
        post.is_liked
    ]);
    var postDetailsUrl = "/".concat(post.user_info.username, "/posts/").concat(post.id);
    var trackAmpEvent = function(eventName) {
        var ref, ref1, ref2, ref3, ref4;
        (0,_amplitude_analytics_browser__WEBPACK_IMPORTED_MODULE_10__/* .track */ .j)(eventName, {
            post_type: post.type,
            media_type: (ref = post.media) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.type,
            comment_count: post.comment_count,
            like_count: post.like_count,
            post_user_id: (ref2 = post.user_info) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.id) === null || ref3 === void 0 ? void 0 : ref3.toString(),
            is_followed: (ref4 = post.user_info) === null || ref4 === void 0 ? void 0 : ref4.is_followed,
            page: screen
        });
    };
    var handleLikeClick = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(postId, isLiked) {
            var action;
            return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (currentAuth) {
                            _ctx.next = 3;
                            break;
                        }
                        showLogin({
                            redirectUrl: postDetailsUrl
                        });
                        return _ctx.abrupt("return");
                    case 3:
                        action = isLiked ? "unlike" : "like";
                        if (isLiked) {
                            setIsLiked(false);
                            setLikeCount(function(count) {
                                return count - 1;
                            });
                            updateLikeInfoOfPost(postId, false);
                        } else {
                            setIsLiked(true);
                            setLikeCount(function(count) {
                                return count + 1;
                            });
                            updateLikeInfoOfPost(postId, true);
                        }
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return axios__WEBPACK_IMPORTED_MODULE_12__/* ["default"].post */ .Z.post("/posts/".concat(postId, "/reaction?action=").concat(action), {});
                    case 8:
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](5);
                        _bugsnag_js__WEBPACK_IMPORTED_MODULE_8___default().notify(_ctx.t0);
                    case 13:
                        trackAmpEvent("Like Post");
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    10
                ]
            ]);
        }));
        return function handleLikeClick(postId, isLiked) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleShareClick = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(postId) {
            return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (currentAuth) {
                            _ctx.next = 3;
                            break;
                        }
                        showLogin({
                            redirectUrl: postDetailsUrl
                        });
                        return _ctx.abrupt("return");
                    case 3:
                        if (!isShared) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 5:
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return axios__WEBPACK_IMPORTED_MODULE_12__/* ["default"].post */ .Z.post("/posts/".concat(postId, "/shares"), {});
                    case 8:
                        if (!isShared) {
                            setIsShared(true);
                            addShareInfoOfPost(postId);
                        }
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](5);
                        _bugsnag_js__WEBPACK_IMPORTED_MODULE_8___default().notify(_ctx.t0);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    11
                ]
            ]);
        }));
        return function handleShareClick(postId) {
            return _ref.apply(this, arguments);
        };
    }();
    var iconSize = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (smallSize) {
            return isMobileScreen ? 16 : 20;
        } else {
            return isMobileScreen ? 16 : 20;
        }
    }, [
        smallSize,
        isMobileScreen
    ]);
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_6___default()((_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().newPostReactionWrapper), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_obj, (_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().isPostDetail), isPostDetail), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_obj, (_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().smallSize), smallSize), _obj)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().line)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().postReActionsWrapper),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: (_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().icon),
                        style: {
                            width: "".concat((100 - viewCountWidthPer) / 3, "%")
                        },
                        onClick: function() {
                            return handleLikeClick(post.id, isLiked);
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                name: "heart",
                                width: iconSize,
                                height: iconSize,
                                isOn: isLiked,
                                hasOn: true
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: (_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().numberWrapper),
                                children: [
                                    !smallSize && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        className: (_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().text),
                                        children: "いいね"
                                    }),
                                    (showNumber || isLiked) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: (_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().number),
                                        children: (0,common_utils__WEBPACK_IMPORTED_MODULE_5__/* .numberToString */ .D$)(likeCount, 1)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().separate)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                        onClick: function() {
                            return handleClickComment && handleClickComment();
                        },
                        style: {
                            width: "".concat((100 - viewCountWidthPer) / 3, "%")
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: (_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().icon),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                    name: "comment",
                                    width: iconSize,
                                    height: iconSize
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: (_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().numberWrapper),
                                    children: [
                                        !smallSize && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                            className: (_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().text),
                                            children: "コメント"
                                        }),
                                        showNumber && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: (_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().number),
                                            children: (0,common_utils__WEBPACK_IMPORTED_MODULE_5__/* .numberToString */ .D$)(post.comment_count, 1)
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().separate)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_6___default()((_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().icon), (_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().shareMenuTrigger)),
                        style: {
                            width: "".concat((100 - viewCountWidthPer) / 3, "%")
                        },
                        ref: shareMenuRef,
                        onClick: function() {
                            if (!currentAuth) {
                                showLogin({
                                    redirectUrl: postDetailsUrl
                                });
                                return;
                            }
                            void handleShareClick(post.id);
                            setPostToShareByPopup(post);
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                name: "share",
                                width: iconSize,
                                hasOn: true,
                                isOn: isShared,
                                height: iconSize
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: (_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().numberWrapper),
                                children: [
                                    !smallSize && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        className: (_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().text),
                                        children: "シェア"
                                    }),
                                    (showNumber || isShared) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: (_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().number),
                                        children: (0,common_utils__WEBPACK_IMPORTED_MODULE_5__/* .numberToString */ .D$)(post.share_count, 1)
                                    })
                                ]
                            })
                        ]
                    }),
                    showViewCount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().separate)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_6___default()((_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().icon), (_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().viewCount)),
                                style: {
                                    width: "".concat(viewCountWidthPer, "%")
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                        name: "view-black",
                                        width: iconSize,
                                        height: iconSize
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: (_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().numberWrapper),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: (_PostReActions_module_scss__WEBPACK_IMPORTED_MODULE_13___default().number),
                                            children: (0,common_utils__WEBPACK_IMPORTED_MODULE_5__/* .numberToString */ .D$)(post.view_count, 1)
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 7923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_common_LabelButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57307);
/* harmony import */ var components_common_RoundIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10184);
/* harmony import */ var common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22467);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _TippedItem_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13224);
/* harmony import */ var _TippedItem_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_TippedItem_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);







var TippedItem = function(param) {
    var tippedInfo = param.tippedInfo, className = param.className, _enableLink = param.enableLink, enableLink = _enableLink === void 0 ? true : _enableLink;
    var ref;
    if (!tippedInfo.tipping_package) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    var tipPaymentData = (0,common_utils__WEBPACK_IMPORTED_MODULE_3__/* .tippingPackageData */ .jb)(tippedInfo);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
        href: "/".concat((ref = tippedInfo.user) === null || ref === void 0 ? void 0 : ref.username),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            style: !tippedInfo.user || !enableLink ? {
                pointerEvents: "none"
            } : {},
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_LabelButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                text: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_TippedItem_module_scss__WEBPACK_IMPORTED_MODULE_6___default().tippedIcon),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_RoundIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                user: tippedInfo.user,
                                width: 20,
                                height: 20
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            children: [
                                "\xa5",
                                tipPaymentData.amount
                            ]
                        })
                    ]
                }),
                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(className),
                type: "tip-".concat(tippedInfo.tipping_package.id)
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TippedItem);


/***/ }),

/***/ 16138:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"newPostReactionWrapper":"PostReActions_newPostReactionWrapper__ymQ5f","isPostDetail":"PostReActions_isPostDetail__KVkAM","line":"PostReActions_line__fdnfR","postReActionsWrapper":"PostReActions_postReActionsWrapper__s7YDo","separate":"PostReActions_separate__yefqB","smallSize":"PostReActions_smallSize__FUdPU","icon":"PostReActions_icon___YvyJ","viewCount":"PostReActions_viewCount__AYkp0","numberWrapper":"PostReActions_numberWrapper__T4D_1","text":"PostReActions_text__KZTk_","number":"PostReActions_number__4v_vl","shareMenuTrigger":"PostReActions_shareMenuTrigger__OItKY","shareMenuWrapper":"PostReActions_shareMenuWrapper__6_hF_","option":"PostReActions_option__A34e4"};

/***/ }),

/***/ 13224:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tippedInfo":"TippedItem_tippedInfo__gqC0F","tippedIcon":"TippedItem_tippedIcon__uxTC_","deletedUser":"TippedItem_deletedUser__PsEZN"};

/***/ })

}]);